module.exports = __webpack_public_path__ + "img/Monk.77b3100e.png";